export const ACTION_MAP = {
  create: 'created',
  update: 'updated',
  delete: 'deleted',
  upload: 'uploaded'
};
